var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWebhook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1272",
    "data-name": "Group 1272",
    transform: "translate(-6029 -2962)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_709",
    "data-name": "Path 709",
    d: "M6040.194,2970.583c-.034,0-.069,0-.1,0a1.608,1.608,0,1,1,1.248-.595l1.777,3.266a4,4,0,1,1-.833,7.1.572.572,0,0,1-.168-.792.553.553,0,0,1,.062-.079l.005,0a.6.6,0,0,1,.763-.1,2.827,2.827,0,1,0,1.537-5.2,3.8,3.8,0,0,0-1.768.529.208.208,0,0,1-.29-.041.251.251,0,0,1-.016-.026Zm-.738,6.949a4,4,0,1,1-5.733-4.272.573.573,0,0,1,.807.344v0a.6.6,0,0,1-.3.71,2.826,2.826,0,1,0,3.734,3.93,3.793,3.793,0,0,0,.426-1.8.207.207,0,0,1,.18-.23h.031l4.63.117c.016-.03.032-.061.049-.091a1.607,1.607,0,1,1-.109,1.378Zm-1.941-5.486a4,4,0,1,1,6.566-2.83.572.572,0,0,1-.6.541.552.552,0,0,1-.1-.013l0,0a.6.6,0,0,1-.466-.613,2.827,2.827,0,1,0-5.271,1.269,3.8,3.8,0,0,0,1.342,1.267.206.206,0,0,1,.11.27.173.173,0,0,1-.014.027l-2.417,3.952c.019.029.037.058.054.088a1.607,1.607,0,1,1-1.139-.783Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_548",
    "data-name": "Rectangle 548",
    width: 22,
    height: 22,
    transform: "translate(6029 2962)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWebhook);
export default __webpack_public_path__ + "static/media/icon-webhook.3e03c093eb1dfbf079a720e4e3f8b85a.svg";
export { ForwardRef as ReactComponent };